export default Object.freeze({
  UserInitiated: 1,
  AdminAssigned: 2,
  SystemAssigned: 3,
  ManualAssignment: 4,
});
